const topics = [
  {
    title: '每日大赛7月冠军赛专题回顾',
    summary: '回顾本月最受关注的冠军赛事全程高光时刻，从海选到决赛的精彩对决一次看完',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20stadium%20arena%20with%20warm%20golden%20spotlights%20and%20confetti%2C%20championship%20atmosphere%2C%20dynamic%20energy%2C%20professional%20sports%20event%20photography%20style%2C%20warm%20toned%20lighting%2C%20grand%20celebration%20scene&width=800&height=480&seq=carousel-01&orientation=landscape',
  },
  {
    title: '每日大赛新手入门完全指南',
    summary: '从零开始了解每日大赛平台的所有功能和使用技巧，快速融入赛事社区',
    image: 'https://readdy.ai/api/search-image?query=A%20friendly%20and%20inviting%20learning%20environment%20with%20a%20clean%20desktop%20setup%2C%20open%20notebook%2C%20warm%20desk%20lamp%2C%20cozy%20atmosphere%2C%20organized%20workspace%2C%20soft%20natural%20light%2C%20modern%20minimalist%20aesthetic&width=800&height=480&seq=carousel-02&orientation=landscape',
  },
  {
    title: '每日大赛APP功能深度评测',
    summary: '全面解析每日大赛APP各项功能模块的实际使用体验和隐藏技巧',
    image: 'https://readdy.ai/api/search-image?query=A%20smartphone%20with%20colorful%20app%20interface%20next%20to%20a%20coffee%20cup%20on%20a%20wooden%20table%2C%20modern%20coffee%20shop%20setting%2C%20warm%20ambient%20light%2C%20lifestyle%20product%20photography%2C%20soft%20bokeh%20background&width=800&height=480&seq=carousel-03&orientation=landscape',
  },
  {
    title: '每日大赛社区文化生态观察',
    summary: '深入了解每日大赛社区的用户互动模式和文化氛围，感受独特的赛事社交体验',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20community%20gathering%20scene%20with%20people%20interacting%2C%20warm%20lighting%2C%20modern%20coworking%20space%2C%20dynamic%20social%20atmosphere%2C%20abstract%20colorful%20elements%2C%20energetic%20and%20positive%20vibe&width=800&height=480&seq=carousel-04&orientation=landscape',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精选每日大赛深度专题内容，全方位了解赛事生态
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {topics.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
            >
              <div className="aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}